import { Prisma } from '@repo/database/src/types';

export const agentDealWithRegion = {
  include: {
    region: {
      select: {
        id: true,
        name: true,
        createdAt: true,
        updatedAt: true,
      },
    },
  },
} satisfies Prisma.AgentDealDefaultArgs;

export type AgentDealWithRegionDto = Prisma.AgentDealGetPayload<typeof agentDealWithRegion>;
